import { Component} from '@angular/core';

@Component({
  selector: 'app-retort-vertical-header',
  standalone: false,
  templateUrl: './retort-vertical-header.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class RetortVerticalHeaderComponent {
}
